<template>
  <div>
    <PrmSkeleton
      v-if="item.loading"
      class="qmulus-breadcrumb-item__loading"
    />
    <component
      :is="isNullish(item.route) ? 'span' : 'router-link'"
      v-else
      :to="item.route ?? undefined"
      :class="{
        'qmulus-breadcrumb-item__route': !isNullish(item.route),
      }"
      class="flex-row-union align-center"
      :data-qa="item.dataQa"
    >
      <template v-if="!isNullish(item.icon)">
        <i
          v-if="typeof item.icon === 'string'"
          :class="item.icon"
        />
        <component
          :is="item.icon"
          v-else
          class="qmulus-breadcrumb-item__component-icon"
        />
      </template>
      {{ item.label }}
    </component>
  </div>
</template>

<script setup lang="ts">
import PrmSkeleton from '@NitrexGroup/primevue/skeleton';

import {
  isNullish,
} from '../../utils/common.ts';

import {
  TBreadcrumbItem,
} from './qmulus-breadcrumb.ts';

defineProps<{
  item: TBreadcrumbItem,
}>();
</script>

<style scoped lang="scss">
@use "sass:math";

$font-size: 1.5rem;

.qmulus-breadcrumb-item {
  &__loading {
    // !important is required to overrule the inline style on the PrmSkeleton
    width: 10rem !important;
    height: $font-size !important;
  }

  // The padding leaves room between the focus ring and the icon and text, and the negative margin keeps
  // them where they were.
  &__route {
    padding: var(--gap-union);
    margin: calc(-1 * var(--gap-union));
    border-radius: var(--border-radius);
    color: var(--primary-color);
    text-decoration: none;

    &:focus-visible {
      outline: 0 none;
      box-shadow: var(--focus-shadow);
    }

    // The app icons leave 4 of their 30 units empty at each side (the older ones 2 of 24), which
    // already looks like space.
    &:has(> .qmulus-breadcrumb-item__component-icon:first-child) {
      $icon-side-space: math.div(4, 30) * $font-size;

      padding-left: max(0rem, calc(var(--gap-union) - #{$icon-side-space}));
      margin-left: min(0rem, calc(#{$icon-side-space} - var(--gap-union)));
    }
  }

  // Both sides, as the icons declare a width of their own, which would add space around them.
  &__component-icon {
    width: $font-size;
    height: $font-size;
  }
}
</style>
